import {alias, createModelSchema, custom, deserialize, list, serialize, SKIP} from "serializr";
import {Schema} from "@/common/Schema";
import {Cloneable} from "@/common/Cloneable";

import {GuardTimeRule} from "@/modules/redactor/models/guard/GuardTimeRule";
import {RepeatInterval} from "@/modules/redactor/models/guard/RepeatInterval";


export class GuardTime extends Cloneable {

    static schema() {
        return custom((v) => {
            return v && !v.empty() ? serialize(GuardTime, v) : SKIP;
        }, (v) => {
            return deserialize(GuardTime, v);
        });
    }

    constructor() {
        super();

        this._rules = [];
        this._profileAge = 0;
        this._startOnLaunch = false;
    }

    get rules() {
        return this._rules;
    }

    set rules(value) {
        this._rules = value;
    }

    get profileAge() {
        return this._profileAge;
    }

    set profileAge(value) {
        this._profileAge = value;
    }

    get startOnLaunch() {
        return this._startOnLaunch;
    }

    set startOnLaunch(value) {
        this._startOnLaunch = value;
    }

    valid() {

        if (!Number.isInteger(this.profileAge) || this.profileAge < 0) {
            return false;
        }

        if (this.rules && this.rules.some(v => !v || !v.valid())) {
            return false;
        }

        if (this.rules.length > 1 && this.rules.some(v => !RepeatInterval.isNone(v.repeatInterval))) {
            return false;
        }

        return true;
    }

    empty() {
        return this.profileAge <= 0 && this.rules.length === 0;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new GuardTime());
        } else if (target instanceof GuardTime) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(GuardTime, {
    _rules: alias("rules", list(GuardTimeRule.schema())),
    _profileAge: alias("profile_age", Schema.primitive()),
    _startOnLaunch: alias("start_launch", Schema.primitive()),
});